import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://03aee969f2d5b26ccfb41446ddad6a3e@o4508785696505856.ingest.de.sentry.io/4508785698209872",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});
